import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from "@angular/router";

export function withLoading<T>(
  resolverFn: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => T,
): ResolveFn<T> {
  return (route, state) => {
    return resolverFn(route, state);
  };
}
